// React import
import React from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
// Actions import
import {hideNotification, showNotification} from "../../actions";
// Svg icons import
import { ReactComponent as CopySvg } from '../../svg-icons/copy.svg';
// Styles imports
import './WalletAddress.css';
import '../../util.css'

async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
        return await navigator.clipboard.writeText(text);
    } else {
        return document.execCommand('copy', true, text);
    }
}

class WalletAddress extends React.Component {

    constructor(props) {
        super(props);
    }

    setNotification = () => {
        const { showNotification, hideNotification } = this.props;
        const duration = 750;

        showNotification({message: "Wallet address copied", duration: duration});
        setTimeout(() => {
            hideNotification();
        }, duration);
    }

    handleClick = async () => {
        const {address} = this.props.checkWallet;
        await copyTextToClipboard(address);
        this.setNotification();
    };

    render () {

        const { shortAddress } = this.props.checkWallet;

        return(
            <div className={"check-wallet__addr"}>
                <span className={"check-wallet__addr__label noselect"}>{shortAddress}</span>

                <div className={"check-wallet__addr__copy-icon-block"} onClick={this.handleClick}>
                    <CopySvg className={"check-wallet__addr__copy-icon"}/>
                </div>
            </div>
        );
    }

}

const mapStateToProps = ({checkWallet, notification}) => {
    return {checkWallet, notification};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        showNotification: showNotification,
        hideNotification: hideNotification
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletAddress);